import React, {PropTypes, Component} from 'react';
import s from './datepicker.scss';
import {DateField, MonthView} from 'react-date-picker';
const dateFormat = 'MM-DD-YYYY';
import utils from '../../../utils/utils';

class DatePickerComponent extends Component {

  focus() {
    this.textInput.focus();
  }

  render() {
    const {open, startDate, endDate, active, toggleDatePickerOpenState, datePickerDatesRange, datePickerEndDate, datePickerStartDate, toggleDatePickerActiveState, getDaysRange, fetchPostsByDate, tag} = this.props;
    let {dateRange} = this.props;
    let range = 0;
    let buttonType = '';
    const calendarClass = active === true ? `${s.active} ${s.calendar}` : `${s.calendar}`;
    const datePickerClass = `${s.datePickerWrapper} ${open ? s.show : ''}`;
    return (
      <div
        className={datePickerClass}
        >
        <svg
          className={s.closeWrapper}
          height="19.94" width="19.969" viewBox="0 0 19.969 19.94"
          onClick={() => {
            toggleDatePickerOpenState(false);
            toggleDatePickerActiveState(false);
          }}
          >
          <path id="Close" d="M250.275,3881.01l-1.082-1.08-8.9,8.9-8.9-8.9-1.082,1.08,8.9,8.9-8.9,8.9,1.082,1.08,8.9-8.9,8.9,8.9,1.082-1.08-8.9-8.9Z" transform="translate(-230.312 -3879.94)"/>
        </svg>
        <div className={calendarClass}>
          <MonthView
            dateFormat={dateFormat}
            weekNumbers={false}
            highlightWeekends={false}
            footer={false}
            defaultRange={dateRange}
            onActiveDateChange={dateString => {
              range = 0;
              buttonType = 'custom search';
              if (dateRange.length === 2) {
                dateRange = [];
              }
              dateRange.push(utils.dateFixSpecialChars(dateString));
              const params = {};
              params.dateRange = dateRange;
              const datesSorted = dateRange.slice(0);
              datesSorted.sort();
              if (datesSorted.length === 2) {
                datePickerEndDate(utils.dateFromString(datesSorted[1]));
              }
              datePickerStartDate(utils.dateFromString(datesSorted[0]));
              datePickerDatesRange(params.dateRange);
            }}
            />
        </div>
        <ul className={`${dateRange.length === 2 ? s.withRange : ''}`}>
          <li
            data-hook="sort-label"
            onClick={() => {
              utils.reportBi('335');
              toggleDatePickerOpenState(true);
              datePickerStartDate(new Date().getTime());
              datePickerEndDate(new Date().getTime());
            }}
            className={s.sortTrigger}
            >
            <span className={s.sortLabel}>{`${dateRange.length === 2 ? `${utils.dateFixSpecialChars(dateRange[0])} - ${utils.dateFixSpecialChars(dateRange[1])}` : 'Sort by Date'}`}</span>
            <svg height="13" width="13" viewBox="0 0 13 13" className={s.calendarIcon}>
              <path id="Date" d="M1967,606.986h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2,0h1v-1h-1v1ZM1967,609h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2,0h1v-1h-1v1Zm-6,2.012h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2,0h1v-1h-1v1Zm2.5-9.01H1974v-1h-1v1h-5v-1h-1v1h-1.5a1.5,1.5,0,0,0-1.5,1.5v9a1.5,1.5,0,0,0,1.5,1.5h10a1.5,1.5,0,0,0,1.5-1.5v-9A1.5,1.5,0,0,0,1975.5,602Zm0.5,10.5a0.5,0.5,0,0,1-.5.5h-10a0.5,0.5,0,0,1-.5-0.5v-9a0.5,0.5,0,0,1,.5-0.5h1.5v1h1v-1h5v1h1v-1h1.5a0.5,0.5,0,0,1,.5.5v9Z" transform="translate(-1964 -601)"/>
            </svg>
          </li>
          <li className={`${s.dateOption}`}>
            <label htmlFor="week">
              <input
                className={s.radioInputBtn}
                type="radio" id="week" name="range" onChange={() => toggleDatePickerActiveState(false)}
                onClick={() => {
                  range = getDaysRange(7);
                  buttonType = 'last week';

                }}
                />
              <span>Last Week</span>
            </label>
          </li>
          <li className={`${s.dateOption}`}>
            <label htmlFor="month">
              <input
                className={s.radioInputBtn}
                type="radio" id="month" name="range" onChange={() => toggleDatePickerActiveState(false)}
                onClick={() => {
                  range = getDaysRange(30);
                  buttonType = 'last month';
                }}
                />
              <span>Last Month</span>
            </label>
          </li>
          <li className={`${s.dateRange} ${s.dateOption}`}>
            <label
              onClick={() => this.focus()}
              >
              <input className={s.radioInputBtn} type="radio" id="date-range" name="range" checked={active}/>
              <span>Data Range</span>
            </label>
            <label className={`${s.datefiled} ${dateRange.length >= 1 ? s.activeLabel : ''}`} data-hook="from-calendar">
              <span>From:</span>
              <span className={s.hide}><DateField
                dateFormat={dateFormat}
                value={startDate}
                expanded={false}
                onFocus={() => toggleDatePickerActiveState(true)}
                ref={input => this.textInput = input}
                /></span>
              <DateField
                dateFormat={dateFormat}
                value={startDate}
                expanded={false}
                />
            </label>
            <label className={`${s.datefiled} ${dateRange.length >= 2 ? s.activeLabel : ''}`} data-hook="to-calendar">
              <span>To:</span>
              <span className={s.hide}><DateField
                dateFormat={dateFormat}
                value={endDate}
                expanded={false}
                onFocus={() => toggleDatePickerActiveState(true)}
                /></span>
              <DateField
                dateFormat={dateFormat}
                value={endDate}
                expanded={false}
                />
            </label>
          </li>
          <li className={s.formWrapper}>
            <div className={s.form}>
              <button
                className={s.filterButton}
                onClick={() => {
                  utils.reportBi('336', `button_name=${buttonType}`);
                  if (range !== 0) {
                    fetchPostsByDate({startDate: range.start, endDate: range.end, tag});
                    toggleDatePickerOpenState(false);
                    toggleDatePickerActiveState(false);
                    datePickerDatesRange([]);
                    return;
                  }
                  if (startDate >= endDate) {
                    return;
                  }
                  toggleDatePickerOpenState(false);
                  toggleDatePickerActiveState(false);
                  fetchPostsByDate({startDate, endDate, tag});
                }}
                >
                Show Updates
              </button>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

DatePickerComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  tag: PropTypes.string.isRequired,
  dateRange: PropTypes.array.isRequired,
  toggleDatePickerOpenState: PropTypes.func.isRequired,
  toggleDatePickerActiveState: PropTypes.func.isRequired,
  datePickerStartDate: PropTypes.func.isRequired,
  datePickerEndDate: PropTypes.func.isRequired,
  datePickerDatesRange: PropTypes.func.isRequired,
  fetchPostsByDate: PropTypes.func.isRequired,
  getDaysRange: PropTypes.func.isRequired
};

export default DatePickerComponent;



// WEBPACK FOOTER //
// ./components/partial/DatePicker/DatePicker.js